import { render } from "./VideoBubbleSelectorPage.vue?vue&type=template&id=6fb1b5b0&scoped=true"
import script from "./VideoBubbleSelectorPage.vue?vue&type=script&lang=js"
export * from "./VideoBubbleSelectorPage.vue?vue&type=script&lang=js"

import "./VideoBubbleSelectorPage.vue?vue&type=style&index=0&id=6fb1b5b0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb1b5b0"]])

export default __exports__